import React, { PureComponent } from 'react';

import ShiftAlert from './ShiftAlert';

export default class LateClockIn extends PureComponent {
  render() {
    return <ShiftAlert {...this.props} />;
  }
}
